import find from 'lodash/find';
import map from 'lodash/map';
import reduce from 'lodash/reduce';

import { EquipmentResponse } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/ResponseDto';

import prepareCharacteristic from '~/src/features/tariffBuilder/helpers/transformer/prepareRouters/prepareCharacteristic';
import prepareCosts from '~/src/features/tariffBuilder/helpers/transformer/prepareRouters/prepareCosts';
import { TRouter } from '~/src/features/tariffBuilder/reducer';

const prepareRouters = (current: Record<number, TRouter>, incoming: Record<number, EquipmentResponse>) => {
    return reduce(incoming, (result: Record<number, TRouter>, incomingRouter, key) => {
        const {
            costs: incomingCosts,
            characteristics: incomingCharacteristics,
            id,
            ...router
        } = incomingRouter;

        const numberKey = Number(key);

        const characteristics = map(incomingCharacteristics.slice(0, 4), prepareCharacteristic);
        const costs = reduce(incomingCosts, prepareCosts, {});

        const currentRouter = find(current, { id: Number(id) });

        if (!currentRouter) {
            result[numberKey] = {
                ...router,
                id: Number(id),
                costs,
                characteristics,

                selectedCost: Math.max(...Object.keys(costs).map(Number)),
                quantity: 0,
            };
        } else {
            result[numberKey] = {
                ...currentRouter,
            };
        }

        return result;
    }, {});
};

export default prepareRouters;
